import * as userTypes from "../user/actions"
import * as enterpriseTypes from "../enterprise/members/actions"
import * as accountantTypes from "../accountants/actions"
import * as subscriptionTypes from "../subscriptions/actions"
import { docCookies } from "../utils/docCookies"
import institutionsReducer from "./institutionsReducer"

const userInitialState = {
  auth_token: docCookies.getItem("auth_token") || null,
  isFetching: false,
  isAuthenticated: docCookies.getItem("auth_token") ? true : false,
  loginResponseStatus: null,
  loginErrorMessage: "",
  signupErrorMessage: "",
  createUserResponseStatus: null,
  email: null,
  token_id: null,
  potential_credits: 0,
  isNetworkError: false,
  //TODO move to own reducer slice for password resets
  title: "Enter Email Address",
  isEnterpriseOwner: false,
  isEnterpriseMember: false,
  isAccountant: false,
  income_sources: [],
  institution_users: [],
  hasSubscription: null,
  hasMobileApp: true,
  custom_expense_categories: [],
  favorite_transactions: [],
  integrations_enabled: [],
  integration_accounts: []
  // subscription: {
  //   customer: {
  //     source: {
  //       brand: null,
  //       exp_month: null,
  //       exp_year: null,
  //       last4: null
  //     }
  //   }
  // }
}

export default function user(state = userInitialState, action) {
  switch (action.type) {
    case "DELETE_FAVE_TXN_SUCCESS":
      return {
        ...state,
        favorite_transactions: [
          ...state.favorite_transactions.filter(ft => ft.id != action.tokenId)
        ]
      }

    case "CREATE_FAVE_TXN_SUCCESS":
      return {
        ...state,
        favorite_transactions: [...state.favorite_transactions, action.data]
      }

    case "UPDATE_FAVE_TXN_SUCCESS":
      // action.data: { id, ...rest}
      return {
        ...state,
        favorite_transactions: [
          ...state.favorite_transactions.map(ft => {
            if (ft.id == action.data.id) return action.data
            return ft
          })
        ]
      }

    case "DISABLE_INTEGRATION_SUCCESS":
      return {
        ...state,
        integrations_enabled: state.integrations_enabled.filter(
          ie => ie != action.integration
        ),
        integration_accounts: state.integration_accounts.filter(
          ia => ia.oauth_token.provider != action.integration
        )
      }

    // case "SHOW_INTEGRATION_SUCCESS":
    //   return {
    //     ...state,
    //     integrations_enabled: [
    //       ...state.integrations_enabled,
    //       "<freshbooks...>"
    //     ],
    //     integration_accounts: [...state.integration_accounts, ...action.payload]
    //   }
    case "TOGGLE_INSTITUTION_ACCOUNT_REQUEST":
    case "TOGGLE_INSTITUTION_ACCOUNT_SUCCESS":

    case "UNLINK_INSTITUTION_USER_SUCCESS":
    case "CREATE_INSTITUTION_USER_SUCCESS":
    case "REFRESH_INSTITUTIONS_SUCCESS":
      return {
        ...state,
        ...institutionsReducer(state, action)
      }

    case "UPDATE_BUSINESS_LINES_SUCCESS":
      return {
        ...state,
        income_sources: action.user.income_sources,
        persona: action.user.persona
      }

    case "GET_TOTALS_SUCCESS":
      return {
        ...state,
        ...action.user.totals,
        ...action.user
      }

    case "RESET_PASSWORD_REQUEST":
      // TODO split into it's own reducer
      return {
        isFetching: true
      }
    case "RESET_PASSWORD_SUCCESS":
      return {
        isFetching: false,
        title: "Sweet! Now check your email"
      }
    case "RESET_PASSWORD_FAIL":
      return {
        isFetching: false
      }
    case enterpriseTypes.ENTERPRISE_MEMBER_FAILURE:
      return {
        ...state,
        isNetworkError: true
      }

    case accountantTypes.CREATE_CLIENT_INVITES_SUCCESS:
      return {
        ...state,
        group_as_accountant: {
          ...state.group_as_accountant,
          invited_clients: action.json
        }
      }

    case accountantTypes.GET_ACCOUNTANT_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group_as_accountant: {
          ...action.json
        }
      })
    case accountantTypes.UPDATE_ACCOUNTANT_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group_as_accountant: action.json
      })
    case accountantTypes.CREATE_ACCOUNTANT_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group_as_accountant: action.json
      })

    case enterpriseTypes.CREATE_MEMBER_INVITES_SUCCESS:
      return Object.assign({}, state, {
        group_as_enterprise_owner: {
          ...state.group_as_enterprise_owner,
          invited_members: action.json
        }
      })
    case enterpriseTypes.GET_ENTERPRISE_GROUP_SUCCESS:
      return Object.assign({}, state, {
        group_as_enterprise_owner: action.json
      })

    case userTypes.CREATE_USER_REQUEST:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        signupErrorMessage: "",
        createUserResponseStatus: null,
        isFetching: action.isFetching
      })
    case userTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        ...action.user,
        isAuthenticated: action.isAuthenticated,
        createUserResponseStatus: action.createUserResponseStatus,
        isEnterpriseOwner: !!action.user.group_as_enterprise_owner,
        isEnterpriseMember: !!action.user.group_as_enterprise_member,
        isAccountant: !!action.user.group_as_accountant,
        isPremium:
          !!action.user.subscription || action.user.trial_days_remaining > 0,
        hasSubscription: !!action.user.subscription,
        isFetching: false,
        hasMobileApp: false
      }
    case userTypes.CREATE_USER_FAILURE:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        createUserResponseStatus: action.createUserResponseStatus,
        isFetching: action.isFetching,
        signupErrorMessage: action.json ? action.json.errors : ""
      })

    case subscriptionTypes.POTENTIAL_CREDITS_SUCCESS:
      return Object.assign({}, state, {
        potential_credits: action.potentialCredits
      })

    case userTypes.LOGIN_REQUEST:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        loginErrorMessage: "",
        loginResponseStatus: null,
        isFetching: true
      })
    case userTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...action.user,
        isAuthenticated: action.isAuthenticated,
        loginResponseStatus: action.loginResponseStatus,
        isEnterpriseOwner: !!action.user.group_as_enterprise_owner,
        isEnterpriseMember: !!action.user.group_as_enterprise_member,
        isAccountant: !!action.user.group_as_accountant,
        isPremium:
          !!action.user.subscription || action.user.trial_days_remaining > 0,
        hasSubscription: !!action.user.subscription,
        isFetching: false,
        hasMobileApp:
          !!action.user.android_device_model || !!action.user.ios_device_model
      }
    case "MOCK_PREMIUM":
      return {
        ...state,
        isPremium: !state.isPremium,
        hasSubscription: !state.hasSubscription
      }
    case "MOCK_ENTERPRISE":
      return {
        ...state,
        isEnterpriseOwner: true,
        isAccountant: false,
        isPremium: true
      }
    case "MOCK_ACCOUNTANT":
      return {
        ...state,
        isAccountant: true,
        group_as_accountant: {
          first_name: "test"
        }
      }

    case userTypes.LOGIN_FAILURE:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        loginResponseStatus: action.loginResponseStatus,
        isFetching: action.isFetching,
        loginErrorMessage: action.json ? action.json.message : ""
      })

    case userTypes.LOGOUT_REQUEST:
      return state
    case userTypes.LOGOUT_SUCCESS:
      return Object.assign({}, userInitialState, {
        auth_token: null,
        isFetching: false,
        isAuthenticated: false,
        email: null,
        first_name: null,
        last_name: null,
        token_id: null
      })

    case userTypes.USER_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case "UPDATE_USER_SUCCESS":
      return {
        ...state,
        ...action.user
      }

    case "MOCK_USER":
      return {
        ...state,
        ...action.user
      }

    case userTypes.USER_SUCCESS:
      return {
        ...state,
        ...action.user,
        isEnterpriseOwner: !!action.user.group_as_enterprise_owner,
        isEnterpriseMember: !!action.user.group_as_enterprise_member,
        isAccountant: !!action.user.group_as_accountant,
        isPremium:
          !!action.user.subscription || action.user.trial_days_remaining > 0,
        hasSubscription: !!action.user.subscription,
        isFetching: false,
        hasMobileApp:
          !!action.user.android_device_model || !!action.user.ios_device_model
        // NOTE: needed only for dev mocks which don't have subscription popuplated with customer obj (from stripe, which then throws errors on /premium)
        // subscription: {
        //   customer: {
        //     source: {
        //       brand: null,
        //       exp_month: null,
        //       exp_year: null,
        //       last4: null
        //     }
        //   },
        //   ...action.user.subscription
        // }
      }

    case subscriptionTypes.CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isPremium: true,
        trial_days_remaining: 0,
        hasSubscription: true,
        subscription: {
          ...action.subscription
        },
        isFetching: false
      }

    case subscriptionTypes.CREATE_SUBSCRIPTION_REQUEST:
    case subscriptionTypes.UPDATE_CARD_REQUEST:
    case subscriptionTypes.UPDATE_SUBSCRIPTION_REQUEST:
    case subscriptionTypes.REACTIVATE_SUBSCRIPTION_REQUEST:
    case subscriptionTypes.CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case subscriptionTypes.UPDATE_CARD_SUCCESS:
    case subscriptionTypes.UPDATE_SUBSCRIPTION_SUCCESS:
    case subscriptionTypes.REACTIVATE_SUBSCRIPTION_SUCCESS:
      // case subscriptionTypes.CANCEL_SUBSCRIPTION_SUCCESS:

      return {
        ...state,
        subscription: {
          ...action.subscription
        },
        isFetching: false
      }

    // BUG on backend. Temp workaroune
    case subscriptionTypes.CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: {
          ...action.subscription,
          customer: {
            ...action.subscription.customer,
            cancel_at_period_end: true
          }
        },
        isFetching: false
      }

    case subscriptionTypes.UPDATE_SUBSCRIPTION_FAILURE:
    case subscriptionTypes.CREATE_SUBSCRIPTION_FAILURE:
    case subscriptionTypes.REACTIVATE_SUBSCRIPTION_FAILURE:
    case subscriptionTypes.CANCEL_SUBSCRIPTION_FAILURE:
    case subscriptionTypes.UPDATE_CARD_FAILURE:
      return {
        ...state,
        isFetching: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/models/user.js